import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const DatePickerClassName = `${CLASS_NAME_PREFIX}-datepicker`;
export const DateTimePickerClassName = `${CLASS_NAME_PREFIX}-datetimepicker`;
export const DatePickerCalenderClassName = `${DatePickerClassName}__calender`;
export const DatePickerCalenderHeaderClassName = `${DatePickerCalenderClassName}-header`;
export const DatePickerFooterClassName = `${DatePickerCalenderClassName}-footer`;
export const DatePickerFooterTodayClassName = `${DatePickerCalenderClassName}-today`;
export const DatePickerFooterClearClassName = `${DatePickerCalenderClassName}-clear`;
export const DateRangePickerClassName = `${CLASS_NAME_PREFIX}-daterangepicker`;
